import moment from "moment";

import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { SubscriptionGroupMyleDto, SubscriptionPaymentDto } from "@/Common/Models/Portal/MedfarPortal";
import { PaymentStatus } from "@/Common/Models/Portal/MedfarPortalEnums";
import { SubscriptionTransactionDetailsPopup } from "./SubscriptionTransactionHistory_TransactionDetailsPopup";
import { TransactionsPaymentPopup } from "./SubscriptionTransactionHistory_TransactionsPaymentPopup";

interface ISubscriptionTransactionHistoryProps {
    patientContactId: string;
    subscription: SubscriptionGroupMyleDto;
    displayUpcomingPayments?: boolean;
}

class SubscriptionTransactionHistoryState {
    public displayMarkAsPaidPopup: boolean;
    public displayMakePaymentPopup: boolean;
    public displayTransactionDetailsPopup: boolean;

    public isLoading: boolean;
    public showSubscriptionPaymentPopup: boolean;
    public showPaymentInfoUpdate: boolean;

    public transactionToDisplay: SubscriptionPaymentDto;

    constructor(s: SubscriptionTransactionHistoryState = null) {
        if (s != null) {
            this.displayMarkAsPaidPopup = s.displayMarkAsPaidPopup;
            this.displayMakePaymentPopup = s.displayMakePaymentPopup;
            this.displayTransactionDetailsPopup = s.displayTransactionDetailsPopup;
            this.isLoading = s.isLoading;
            this.showSubscriptionPaymentPopup = s.showSubscriptionPaymentPopup;
            this.showPaymentInfoUpdate = s.showPaymentInfoUpdate;
            this.transactionToDisplay = s.transactionToDisplay;
        }
    }
}

class SubscriptionTransactionHistory extends React.Component<ISubscriptionTransactionHistoryProps, SubscriptionTransactionHistoryState> {
    constructor(props: ISubscriptionTransactionHistoryProps) {
        super(props);
        this.state = new SubscriptionTransactionHistoryState();
    }

    public render(): JSX.Element {
        let self = this;
        let hasSubscription = this.props.subscription != null;
        let lockPaymentDisabled = hasSubscription ? !this.props.subscription.HasUnpaidPayments : true;
        let result: JSX.Element = null;
        let paymentHistory: SubscriptionPaymentDto[] = [];
        if (hasSubscription && this.props.subscription != null && this.props.subscription.SubscriptionPayments != null)
            paymentHistory = this.props.subscription.SubscriptionPayments.map(x => x);

        if (paymentHistory == null) paymentHistory = [];
        if (this.props.subscription != null && this.props.subscription.UpcomingPayment != null && this.props.displayUpcomingPayments)
            paymentHistory.push(this.props.subscription.UpcomingPayment);

        paymentHistory = ArrayHelper.SortDynamic(paymentHistory, "BillDate", true);

        result = (
            <div>

                {(this.state.displayMarkAsPaidPopup || this.state.displayMakePaymentPopup) && (
                    <TransactionsPaymentPopup
                        lateTransactions={self.getLateTransactions(paymentHistory)}
                        onCloseCallback={self.closePaymentPopup.bind(self)}
                        subscriptionId={self.props.subscription.SubscriptionGroupId}
                        isMarkAsPaid={self.state.displayMarkAsPaidPopup}
                        patientContactId={self.props.patientContactId}
                    />
                )}

                {this.state.displayTransactionDetailsPopup && (
                    <SubscriptionTransactionDetailsPopup
                        patientContactId={this.props.patientContactId}
                        subscription={this.props.subscription}
                        payment={this.state.transactionToDisplay}
                        onCloseCallBack={this.closeTransactionDetailsPopup.bind(this)}
                    />
                )}

                <div className="block separated">
                    <div className="flex-container heading">
                        <h3 className="thin-font"> {cacheStore.GetString("SubscriptionLabel")}: {cacheStore.GetString("PaymentHistoryLabel")}
                        </h3>
                        <div>
                            <div className="flex-container">
                                <button disabled={lockPaymentDisabled || !hasSubscription} onClick={this.displayMarkAsPaidPopup.bind(this)} className="btn btn-primary push-right-5">
                                    <span>{cacheStore.GetString("CompletePaymentAction")}</span>
                                </button>
                                <button disabled={lockPaymentDisabled || !hasSubscription} onClick={this.displayMakePaymentPopup.bind(this)} className="btn btn-primary">
                                    <span>{cacheStore.GetString("CompletePaymentLabel")}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="psingle-column centered">

                        {this.props.subscription == null &&
                            <div style={{ paddingBottom: "10px" }} className="center"> {cacheStore.GetString("NoSubscriptionLabel")} </div>
                        }

                        {paymentHistory != null && paymentHistory.length > 0 && (
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>{cacheStore.GetString("CreationDateLabel")}</th>
                                        <th>{cacheStore.GetString("DueDateLabel")}</th>
                                        <th>{cacheStore.GetString("DescriptionDLabel")}</th>
                                        <th>{cacheStore.GetString("AmountLabel")}</th>
                                        <th>{cacheStore.GetString("StatusLabel")}</th>
                                        <th>{cacheStore.GetString("TransactionLabel")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paymentHistory.map((t, i) => {
                                        let paymentStateClass = PortalHelper.getPaymentStatusClass(t.PaymentStatus);

                                        return (
                                            <tr key={"paymentHistory_" + i}>
                                                <td>{moment(t.DateCreated).format("YYYY-MM-DD")}</td>
                                                <td>{moment.utc(t.BillDate).format("YYYY-MM-DD")}</td>
                                                <td>{t.Description}</td>
                                                <td>{t.Amount.Total.toFixed(2)}$</td>
                                                <td className={paymentStateClass}>
                                                    <strong>
                                                        {PortalHelper.getPaymentStatusLabel(t.PaymentStatus)}
                                                    </strong>
                                                </td>
                                                <td>
                                                    <a onClick={this.displayTransactionDetailsPopup.bind(this, t)}> {PortalHelper.getTransactionDisplayString(t)} </a>
                                                </td>
                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </table>
                        )}
                        {paymentHistory == null &&
                            <div style={{ paddingBottom: "10px" }} className="center">{cacheStore.GetString("TransactionNotFound")}</div>
                        }
                    </div>
                </div>
            </div>
        );

        return result;
    }

    private closePaymentPopup(): void {
        var s = new SubscriptionTransactionHistoryState();
        s.displayMarkAsPaidPopup = false;
        s.displayMakePaymentPopup = false;
        this.setState(s);
    }

    private displayMarkAsPaidPopup(): void {
        var s = new SubscriptionTransactionHistoryState();
        s.displayMarkAsPaidPopup = true;
        this.setState(s);
    }

    private displayMakePaymentPopup(): void {
        var s = new SubscriptionTransactionHistoryState();
        s.displayMakePaymentPopup = true;
        this.setState(s);
    }

    private getLateTransactions(allTransactions: SubscriptionPaymentDto[]): SubscriptionPaymentDto[] {
        return allTransactions.filter((x: SubscriptionPaymentDto) => x.PaymentStatus == PaymentStatus.Unpaid);
    }

    private displayTransactionDetailsPopup(trx: SubscriptionPaymentDto, e: React.MouseEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        var s = new SubscriptionTransactionHistoryState();
        s.displayTransactionDetailsPopup = true;
        s.transactionToDisplay = trx;
        this.setState(s);
    }

    private closeTransactionDetailsPopup(): void {
        var s = new SubscriptionTransactionHistoryState();
        s.displayTransactionDetailsPopup = false;
        this.setState(s);
    }
}

export { SubscriptionTransactionHistory };
